module.exports = __webpack_public_path__ + "img/avatar_blank.d70c1648.png";